import { CommercialCardImageHeight, } from '../../../../../../components/commercialCard/types/commercialCardTheme';
export const verticalCommonStyles = (FOUNDATIONS, FONT) => ({
    showToggle: false,
    showButton: true,
    showContentSlot: true,
    container: {
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
        border_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_containerradius,
        flex_direction: 'column',
        padding: FOUNDATIONS.spacing_100,
        background_color: FOUNDATIONS.color_neutral_bg_onsurface_100,
        width: '100%',
    },
    imageContainer: {
        height: FOUNDATIONS.size_650,
        border_top_left_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_image_radiussize,
        border_top_right_radius: FOUNDATIONS.radius_comp_commercial_commercialcard_image_radiussize,
        margin_bottom: FOUNDATIONS.spacing_100,
        [CommercialCardImageHeight.SHORT]: {
            height: FOUNDATIONS.size_650,
        },
        [CommercialCardImageHeight.LONG]: {
            height: FOUNDATIONS.size_850,
        },
    },
    contentContainer: {
        padding: FOUNDATIONS.spacing_200,
    },
    contentSlotContainer: {
        display: 'flex',
        flex_direction: 'column',
        width: '100%',
        padding_top: FOUNDATIONS.spacing_250,
        padding_bottom: FOUNDATIONS.spacing_100,
    },
});
//# sourceMappingURL=verticalCommon.js.map